import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';

import LoadingOverlay from '../../common-components/LoadingOverlay';

import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as downloadRequestReducers from '../../download-request/reducer';
import * as slowDataReducers from '../reducer';

import * as slowDataActionMgr from '../action-mgr';
import * as downloadRequestActionMgr from '../../download-request/action-mgr';

import * as strings from '../../helpers/strings';
import { graphViewPeriod, months, aggregations } from '../../helpers/constants';
import { getDaysInMonth, getFastDataStationId } from '../../helpers/common';
import { Paper } from '@material-ui/core';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

// importing Css
import '../../index.css';
const styles = {
  graphViewButton: { height: 30, border: "1px solid rgba(0,0,0,0.5)", lineHeight: "30px", paddingLeft: 16, paddingRight: 16 },
  selected: { background: "rgba(0,0,0,0.1)" }
}

var defaultStation;
var oneTime = 0;

class DMYLineGraphScreen extends Component {

  constructor() {
    super();

    this.handleStationChange = this.handleStationChange.bind(this);
    this.handleSelectView = this.handleSelectView.bind(this);
    this.handleSelectMonth = this.handleSelectMonth.bind(this);
    this.handleSelectYear = this.handleSelectYear.bind(this);
    this.handleSelectDay = this.handleSelectDay.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleSelectAgg = this.handleSelectAgg.bind(this);
    this.loadData = this.loadData.bind(this);
    this.handleSelectRange = this.handleSelectRange.bind(this);
    this.checkUpdateStationTime = this.checkUpdateStationTime.bind(this);

    this.state = {
      stationId: null,
      showDateValidationDialog: false,
      showDownloadButton: true,
      downloadButtonDisabled: true, // New state variable
    }

  }
  componentDidUpdate(prevProps) {
    if (prevProps.queryHistoryData !== this.props.queryHistoryData) {
      const hasData = this.props.queryHistoryData.length > 0 && Object.keys(this.props.queryHistoryData[0]).length > 1;
      this.setState({ downloadButtonDisabled: !hasData });
    }
  }
  componentWillMount() {
    const { fetchGraphReferences, selectStation, stations, yearIndices, loadYearIndices, selectedStationId, getStationTimeOffset } = this.props;


    if (stations.length > 0) {
      if (stations.filter(station => station.id === getFastDataStationId()).length !== 0) {
        defaultStation = stations.filter(station => station.id === getFastDataStationId())[0].id;
      } else {
        defaultStation = stations[0].id;
      }
      selectStation(defaultStation);
      this.setState({ stationId: defaultStation })

      fetchGraphReferences(defaultStation);

      if (!yearIndices.length)
        loadYearIndices();

      const { selectedDay, selectedMonth, selectedYear, selectedAgg, selectedView, rawData } = this.props;

      if (!rawData.length && stations.length) {
        var stationId = selectedStationId || stations[0].id;
        const selectedStation = stations.filter(station => station.id === stationId)[0];
        getStationTimeOffset(selectedStation)
        // .then(() => {
        //   this.loadData(selectedYear, selectedMonth, selectedDay, selectedView, defaultStation, selectedAgg);
        // });
      }
    }
  }

  shouldComponentUpdate() {
    const { getSelectedField, getStnAvaliableTime, getQueryHistoryData, selectDay, selectMonth, selectYear, selectedStationId, fetchDownloadAvaliableTime } = this.props;

    if (getSelectedField.length > 0 && oneTime === 0 && getStnAvaliableTime.stationId) {

      var defaultDate = new Date(getStnAvaliableTime.endDate)
      var arrDefaultDate = getStnAvaliableTime.endDate.split('-')

      const data = {
        "stationId": defaultStation,
        "computeMode": "default",
        "fields": getSelectedField.toString(),
        "choiceDate": "day",
        "queryDate": "" + defaultDate.valueOf()
      }
      getQueryHistoryData(data);

      selectDay(parseInt(arrDefaultDate[2]));
      selectMonth(parseInt(arrDefaultDate[1]));
      selectYear(parseInt(arrDefaultDate[0]));

      oneTime++;
    }

    if (oneTime === 1 && this.state.stationId !== selectedStationId) {
      // fetchDownloadAvaliableTime(selectedStationId)
    }

    return true
  }

  checkSelectedDate = () => {
    const { selectedYear, selectedMonth, selectedDay } = this.props;
    const currentDate = new Date();
    const selectedDate = new Date(selectedYear, selectedMonth - 1, selectedDay);
    
    // Check if the selected month is the current month
    if (
      selectedDate.getFullYear() === currentDate.getFullYear() &&
      selectedDate.getMonth() === currentDate.getMonth()
    ) {
      // Check if the selected day is in the future within the current month
      if (selectedDate > currentDate) {
        return false; // Show the dialog prompt
      }
      return true; // Allow dates within the current month in the past
    } else {
      // Check if the selected date is in the future
      return selectedDate <= currentDate;
    }
  };
  

  handleSelectDay = event => {
    const { selectDay } = this.props;
    const day = parseInt(event.target.value, 0);

    // Hide download button when there's a change in selected day
    this.setState({ downloadButtonDisabled: true, selectedDay: day }); 

    selectDay(day);
  }

  handleSelectMonth = event => {
    const { selectMonth } = this.props;
    const month = parseInt(event.target.value, 0);

    // Hide download button when there's a change in selected month
    this.setState({ downloadButtonDisabled: true, selectedMonth: month });

    selectMonth(month);
  }

  handleSelectYear = event => {
    const { selectYear } = this.props;
    const year = parseInt(event.target.value, 0);

    // Hide download button when there's a change in selected year
    this.setState({ downloadButtonDisabled: true, selectedYear: year });

    selectYear(year);
  }

  handleSelectRange = event => {
    const { selectView, selectMonth, selectDay } = this.props;
    let targetData = event.target.value;
  
    // Hide download button when there's a change in display mode
    this.setState({ downloadButtonDisabled: true, selectedDisplayMode: targetData });

    switch (targetData) {
      case "day":
        selectView(targetData);
        break;
      case "month":
        selectView(targetData);
        selectDay(""); // Reset selectedDay when changing to "Month" view
        break;
      case "year":
        selectView(targetData);
        // selectMonth(""); // Reset selectedMonth when changing to "Year" view
        // selectDay("");   // Reset selectedDay when changing to "Year" view
        break;
      default:
    }
  }

  handleStationChange = event => {
    const { selectStation, getFindStationFields, fetchGraphReferences, getStationTimeOffset, stations, resetSelectFields, fetchDownloadAvaliableTime } = this.props;

    const selectedStationId = event.target.value;
    selectStation(selectedStationId);
    fetchGraphReferences(selectedStationId);
    resetSelectFields();

    const selectedStation = stations.filter(station => station.id === selectedStationId)[0];
    getStationTimeOffset(selectedStation)

    const selectedName = stations.filter(station => station.id === selectedStationId)[0].name;
    getFindStationFields(selectedName);


    fetchDownloadAvaliableTime(selectedName)
    this.setState({ stationId: selectedStation.id })

    setTimeout(() => {

      this.checkUpdateStationTime();

    }, 1000)


  }

  checkUpdateStationTime = () => {
    const { getStnAvaliableTime, selectDay, selectMonth, selectYear } = this.props

    if (getStnAvaliableTime.endDate) {
      var arrDefaultDate = getStnAvaliableTime.endDate.split('-')

      selectDay(parseInt(arrDefaultDate[2]));
      selectMonth(parseInt(arrDefaultDate[1]));
      selectYear(parseInt(arrDefaultDate[0]));
    } else {
      selectDay("");
      selectMonth("");
      selectYear("");
    }
  }

  handleSelectView = view => () => {
    const { selectView } = this.props;
    selectView(view);
  }

  handleRefresh = () => {
    const { selectedView, selectedDay, selectedMonth, selectedYear, selectedStationId, selectedAgg, } = this.props;
    this.loadData(selectedYear, selectedMonth, selectedDay, selectedView, selectedStationId);
    // Set showDownloadButton to true after performing actions
    this.setState({
      showDownloadButton: true,
      downloadButtonDisabled: false,
      selectedDisplayMode: selectedView,
      selectedDay: selectedDay,
      selectedMonth: selectedMonth,
      selectedYear: selectedYear,
      selectedAgg: selectedAgg,
    });
  }

  handleSelectAgg = event => {
    const { selectAgg } = this.props;
    const agg = event.target.value;

    // Hide download button when there's a change in aggregation selection
    this.setState({ downloadButtonDisabled: true, selectedAgg: agg });

    selectAgg(agg);
  }

  loadData = (year, month, day, view, stationId, agg) => {
    const { selectedView, selectedAgg, getQueryHistoryData, getSelectedField, stations, getFindStationFields, selectedDay, selectedMonth, selectedYear } = this.props;
    const selectedStationId = stations.filter(station => station.id === stationId)[0].id;
    const selectedName = stations.filter(station => station.id === stationId)[0].name;

    // if (this.state.stationId !== selectedStationId) {
    //   getFindStationFields(selectedName);
    // }

    let custday = (view === "month") ? 1 : selectedDay

    const utcDate = new Date(Date.UTC(selectedYear, selectedMonth - 1, custday, 0, 0, 0));
    const data = {
      "stationId": selectedStationId,
      "computeMode": selectedAgg,
      "fields": getSelectedField.toString(),
      "choiceDate": selectedView,
      "queryDate": "" + utcDate.valueOf()
    }

    getQueryHistoryData(data);
  }

  handleDownloadClick = () => {
    // props
    const {
      selectedView,
      selectedDay,
      selectedMonth,
      selectedYear,
      selectedStationId,
      selectedAgg,
      getSelectedField,
      queryHistoryData,
      stations
    } = this.props;
  
    // Check if there is data to download
    if (queryHistoryData.length === 0) {
      // No data selected, handle accordingly
      return;
    }

    // Find the selected station
    const selectedStation = stations.find(station => station.id === selectedStationId);
    if (!selectedStation) {
      return;
    }
    
    // Check if the selected view is 'day'
    const includeTimeInHeader = selectedView === graphViewPeriod.day;

    // Create an array for the header fields
    const headerFields = [];

    // Add 'Date' to the header fields
    headerFields.push('Date');

    // If the selected view is 'day', add 'Time' to the header fields
    if (includeTimeInHeader) {
      headerFields.push('Time');
    }

    // Add the remaining fields from queryHistoryData
    headerFields.push(...Object.keys(queryHistoryData[0]).filter(key => key !== 'timestamp'));

    // Join the header fields into a comma-separated string
    const header = headerFields.join(',');
  
    // Construct the data rows with formatted date strings
    const csvRows = queryHistoryData.map(data => {
      // Data formatting
      
      const queryDateTimestamp = data.timestamp; // Get the timestamp from the data
  
      // Remove the 'timestamp' field from the data and format the rest
      const { timestamp, ...formattedData } = {
        ...data,
        // Convert the epoch queryDate to human-readable timestamp
        queryDate: selectedView === graphViewPeriod.day
        ? new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false // 24-hour format
          }).format(new Date(queryDateTimestamp))
        : new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          }).format(new Date(queryDateTimestamp)),
      };

      // Create an array to store the values for each row
      const rowValues = [];

      // If includeTimeInHeader is true and formattedData.queryTime is defined, add the trimmed time value
      if (includeTimeInHeader && formattedData.queryTime !== undefined) {
        rowValues.push(formattedData.queryTime.trim());
      }
      
      // Add formattedDate to the row values
      rowValues.push(formattedData.queryDate);
      
      // Loop through the other fields and replace 0.00 with "NA"
      Object.keys(data).forEach(key => {
        if (key !== 'timestamp') {
          const newValue = data[key] === '0.00' ? 'NA' : data[key];
          rowValues.push(newValue);
        }
      });

      // Join the formatted data values as a CSV row
      const csvRow = rowValues.join(',');
      return csvRow;
    });
  
    // Combine header and rows with newline characters
    const csvData = '\uFEFF' + header + '\n' + csvRows.join('\n');

    // Construct the filename using user-selected date components
    let filename = `${selectedStation.name}_${selectedYear}`;

    if (selectedMonth) {
      filename += `-${selectedMonth}`;
    }

    if (selectedDay) {
      filename += `-${selectedDay}`;
    }

    // Additional logic for filename enhancement
    if (selectedView === graphViewPeriod.year) {
      // If selectedView is year, filename includes only year
      filename = `${selectedStation.name}_${selectedYear}`;
    } else if (selectedView === graphViewPeriod.month) {
      // If selectedView is month, filename includes year and month
      filename += ".csv";
    } else if (selectedView === graphViewPeriod.day) {
      // If selectedView is day, filename includes year, month, and day
      filename += ".csv";
    }
  
    // Create Blob and trigger download 
    // Browsers don't directly allow you to trigger a download using the raw binary data. To trigger a file download, you need to provide a URL that points to the data.
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' }); // Set the character encoding to UTF-8
    const url = URL.createObjectURL(blob); //url acts as an intermediary between your JavaScript code and the actual binary data.
  
    // Create a hidden 'a' element for the download link
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
  
    // Revoke the Object URL to free up resources
    URL.revokeObjectURL(url);
  }
  
  render = () => {
    const { stations, selectedStationId, selectedView, selectedDay, selectedMonth, selectedYear, selectedAgg, isFetching, yearIndices, isGraphReferenceFetching } = this.props;

    let location = "";
    const selectedStation = stations.filter(station => station.id === selectedStationId)[0];
    if (selectedStation) {
      location = selectedStation.location;
    }
    let sortStation = stations;

    return (
      <div>
        {(isGraphReferenceFetching || isFetching) && <LoadingOverlay />}
        <Paper className="filterHistoricalPaper">
          <Grid container alignItems="center">
            <Grid item  md={12} xs={12}>
              <FormControl margin={strings.txtNormal}>
                <InputLabel htmlFor={strings.idSelectStation}>{strings.lblStation}</InputLabel>
                <Select
                  value={selectedStationId}
                  onChange={this.handleStationChange}
                  inputProps={{
                    name: strings.lblStation,
                    id: strings.idSelectStation,
                  }}
                >
                  {sortStation.sort((a, b) => (a.name > b.name) ? 1 : -1).map(station =>
                    <MenuItem key={station.id} value={station.id}>{station.name} - {station.description}</MenuItem>
                  )}
                </Select>
              </FormControl>
              <Typography variant="body1">{location}</Typography>

            </Grid>
            <Grid item  md={12} xs={12}>
              <FormControl margin={strings.txtNormal} style={{ width: '100px' }}>
                <InputLabel htmlFor={strings.idSelectYear}>{strings.lblDisplayMode}</InputLabel>
                <Select
                  value={selectedView}
                  onChange={this.handleSelectRange}
                  inputProps={{
                    name: strings.lblRange,
                    id: strings.idSelectRange,
                  }}
                >
                  <MenuItem key={graphViewPeriod.day} value={graphViewPeriod.day}>{strings.lblDay}</MenuItem>
                  <MenuItem key={graphViewPeriod.month} value={graphViewPeriod.month}>{strings.lblMonth}</MenuItem>
                  <MenuItem key={graphViewPeriod.year} value={graphViewPeriod.year}>{strings.lblYear}</MenuItem>
                </Select>
              </FormControl>  
              {(selectedView === graphViewPeriod.day) &&
              <FormControl margin={strings.txtNormal} style={{ marginLeft: 5 }}>
                <InputLabel htmlFor={strings.idSelectDay}>{strings.lblDay}</InputLabel>
                <Select
                  value={selectedDay}
                  onChange={this.handleSelectDay}
                  inputProps={{
                    name: strings.lblDay,
                    id: strings.idSelectDay,
                  }}
                >
                  {getDaysInMonth(selectedYear, selectedMonth).map(day =>
                    <MenuItem key={day} value={day}>{day}</MenuItem>
                  )}
                </Select>
              </FormControl>
              }
              {(selectedView === graphViewPeriod.day || selectedView === graphViewPeriod.month) &&
                <FormControl margin={strings.txtNormal} style={{ marginLeft: 5 }}>
                  <InputLabel htmlFor={strings.idSelectMonth}>{strings.lblMonth}</InputLabel>
                  <Select
                    value={selectedMonth}
                    onChange={this.handleSelectMonth}
                    inputProps={{
                      name: strings.lblMonth,
                      id: strings.idSelectMonth,
                    }}
                    style={{ width: '110px' }}
                  >
                    {months.map(month =>
                      <MenuItem key={month.value} value={month.value}>{month.name}</MenuItem>
                    )}
                  </Select>
                </FormControl>
              }
              <FormControl margin={strings.txtNormal} style={{ marginLeft: 5 }}>
                <InputLabel htmlFor={strings.idSelectYear}>{strings.lblYear}</InputLabel>
                <Select
                  value={selectedYear}
                  onChange={this.handleSelectYear}
                  inputProps={{
                    name: strings.lblYear,
                    id: strings.idSelectYear,
                  }}
                >
                  {yearIndices.map(yearIndex =>
                    <MenuItem key={yearIndex.year} value={yearIndex.year}>{yearIndex.year}</MenuItem>
                  )}
                </Select>
              </FormControl>   
            </Grid>
            <Grid item  md={12} xs={12}>
              <div className='aggDiv'>
                <FormControl margin={strings.txtNormal} style={{ width: '150px' }}>
                  <InputLabel htmlFor={strings.idSelectAgg}>{strings.lblAggMethod}</InputLabel>
                  <Select
                    value={selectedAgg}
                    onChange={this.handleSelectAgg}
                    inputProps={{
                      name: strings.lblAggMethod,
                      id: strings.idSelectAgg
                    }}
                  >
                    {aggregations.map(agg =>
                      <MenuItem key={agg.value} value={agg.value}>{agg.name}</MenuItem>
                    )}
                  </Select>
                </FormControl>
                  {(stations.length > 0) ?
                    <Button
                      variant="contained"
                      color={strings.colorPrimary}
                      onClick={() => {
                        if (this.checkSelectedDate()) {
                          this.handleRefresh();
                        } else {
                          this.setState({ showDateValidationDialog: true });
                        }
                      }}
                      size="medium"
                      style={{
                        position: 'relative'
                      }}
                    >
                      {strings.lblSubmit}
                    </Button>
                    : null}
                    
                    {(this.state.showDownloadButton && this.props.queryHistoryData.length > 0) && (
                      <Button
                        variant="contained"
                        color={strings.colorPrimary}
                        onClick={() => {
                          this.handleDownloadClick();
                        }}
                        size="medium"
                        disabled={this.state.downloadButtonDisabled} // Disable the button when downloadButtonDisabled is true
                        style={{
                          position: 'relative',
                          opacity: this.state.showDownloadButton ? 1 : 0.5, // Adjust opacity based on showDownloadButton state
                        }}
                      >
                        {strings.lblDownload}
                      </Button>
                    )}
              </div>
              
            </Grid>

          </Grid>
        </Paper>
        <Dialog
          open={this.state.showDateValidationDialog}
          onClose={() => this.setState({ showDateValidationDialog: false })}
        >
          <DialogTitle>Date Validation</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The selected date is in the future. Please select a valid date.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ showDateValidationDialog: false })} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div >
    );
  }
}

const mapStateToProps = state => ({
  stations: userStationsReducers.getStations(state),
  rawData: slowDataReducers.getRawData(state),
  fieldValueMapping: slowDataReducers.getStationGraphFields(state),
  graphReferences: slowDataReducers.getGraphReferences(state),
  selectedStationId: slowDataReducers.getStationId(state),
  selectedView: slowDataReducers.getSelectedView(state),
  selectedDay: slowDataReducers.getSelectedDay(state),
  selectedMonth: slowDataReducers.getSelectedMonth(state),
  selectedYear: slowDataReducers.getSelectedYear(state),
  selectedAgg: slowDataReducers.getSelectedAgg(state),
  isFetching: slowDataReducers.getIsFetching(state),
  isGraphReferenceFetching: slowDataReducers.getIsGraphReferenceFetching(state),
  yearIndices: slowDataReducers.getYearIndices(state),
  stationTimeOffset: slowDataReducers.getStationTimeOffset(state),
  findStationFields: slowDataReducers.getFindStationFields(state),
  queryHistoryData: slowDataReducers.getqueryHistoryData(state),
  getSelectedField: slowDataReducers.getSelectedField(state),

  getStnAvaliableTime: downloadRequestReducers.getStnAvaliableTime(state)
});

const mapActionsToProps = {
  toggleField: slowDataActionMgr.toggleField,
  selectStation: slowDataActionMgr.selectStation,
  selectView: slowDataActionMgr.selectView,
  loadDayData: slowDataActionMgr.loadDayData,
  loadMonthData: slowDataActionMgr.loadMonthData,
  loadYearData: slowDataActionMgr.loadYearData,
  selectDay: slowDataActionMgr.selectDay,
  selectYear: slowDataActionMgr.selectYear,
  selectMonth: slowDataActionMgr.selectMonth,
  selectAgg: slowDataActionMgr.selectAgg,
  fetchGraphReferences: slowDataActionMgr.fetchGraphReferences,
  loadYearIndices: slowDataActionMgr.loadYearIndices,
  getStationTimeOffset: slowDataActionMgr.getStationTimeOffset,
  getFindStationFields: slowDataActionMgr.getFindStationFields,
  getQueryHistoryData: slowDataActionMgr.getQueryHistoryData,
  resetSelectFields: slowDataActionMgr.resetSelectFields,

  fetchDownloadAvaliableTime: downloadRequestActionMgr.fetchDownloadAvaliableTime,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(DMYLineGraphScreen)
);